import { render, staticRenderFns } from "./MTextVertical.vue?vue&type=template&id=72fafa12&"
import script from "./MTextVertical.vue?vue&type=script&lang=js&"
export * from "./MTextVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports